<template>
  <b-container class="pb-3">
    <b-row>
      <b-col md="6" offset-md="3">
        <div v-if="!saving">
          <b-jumbotron>
            <h3>Welcome to CEO Circle</h3>
            <p>We're a global network of 25,000 CEOs who help each other succeed. Our members enjoy a wide range of benefits including:</p>
            <ul>
              <li>Business and Customer Matching</li>
              <li>Investor Matching</li>
              <li>Talent Matching</li>
              <li>Mentor Matching</li>
              <li>Peer Groups</li>
              <li>Global Perks</li>
            </ul>
            <div>
              <b>Membership is free, by invitation only.</b>
            </div>
          </b-jumbotron>
          <b-form-group label="Name" description="Your full name, please.">
            <b-form-input name="name" autocomplete="name" v-model="draft.name"></b-form-input>
          </b-form-group>
          <b-form-group label="Email" description="Your work email, if possible.">
            <b-form-input name="email" type="email" autocomplete="email" v-model="draft.email"></b-form-input>
          </b-form-group>
          <b-form-group label="Phone" description="Your work or personal cell phone number, please">
            <!-- <b-form-input name="phone" type="tel" autocomplete="tel" v-model="draft.phone"></b-form-input> -->
            <vue-tel-input v-model="draft.phone" mode="international"
            ></vue-tel-input>
          </b-form-group>
          <b-button block variant="primary" @click="next()" :disabled="!draft.email || !draft.name">Next</b-button>
        </div>
        <div class="text-center" v-if="saving">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2376460&conversionId=3003196&fmt=gif" />
  </b-container>
</template>
<script>
import Bowser from 'bowser';
import $member from '@/services/member';
import $mailcheck from '@/services/mailcheck';
import { VueTelInput } from 'vue-tel-input';

export default {
  components: {
    VueTelInput,
  },
  data() {
    return {
      draft: {
        jobTitle: 'CEO',
      },
      saving: false,
    };
  },
  methods: {
    async next() {
      this.saving = true;
      const isPublic = $mailcheck(this.draft.email);
      if (!isPublic) {
        this.draft.domain = this.draft.email.split('@')[1];
        console.log(this.draft.domain);
      }
      await $member.create(this.draft);
      this.saving = false;
      if (isPublic) {
        this.$router.push({ name: 'Company' });
      } else {
        this.$router.push({ name: 'Interview', params: { qid: 'primaryChallenges' } });
      }
    },
  },
  async created() {
    const locationInfo = await fetch('https://ipapi.co/json/').then((r) => r.json());
    const browserInfo = Bowser.parse(window.navigator.userAgent);
    this.draft.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.draft.location = locationInfo;
    this.draft.browser = browserInfo;
    this.draft.useragent = window.navigator.userAgent;
  },
};

</script>
